"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _registerOrAuthorizeUser = require("./registerOrAuthorizeUser");
Object.keys(_registerOrAuthorizeUser).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _registerOrAuthorizeUser[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _registerOrAuthorizeUser[key];
    }
  });
});